<template>
  <v-card>
    <v-card-title> Notes </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <NoteItem v-for="note in notes" :key="note.id" :note="note" />
        </v-col>

        <v-col cols="12">
          <v-textarea v-model="comment" label="Add note" auto-grow outlined />
          <v-btn
            :loading="buttonLoading"
            rounded
            depressed
            large
            color="primary"
            :disabled="!comment"
            @click="createNote()"
          >
            Save
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>

    <ErrorSnackbar v-model="showError" />
    <SuccessSnackbar v-model="showSuccess" :message="successMessage" />
  </v-card>
</template>

<script lang="js">
  import SuccessSnackbar from '../../../common/SuccessSnackbar.vue';
  import ErrorSnackbar from '../../../common/ErrorSnackbar.vue';
  import { formHelperMixin } from '../../../../mixins/form-helper-mixin';
  import {
    CREATE_NOTE_MUTATION,
    TESTATOR_NOTES_QUERY,
  } from '../../../../constants/graphql/notes';
  import NoteItem from './NoteItem.vue';

  export default {
    name: 'NotesCard',
    components: {
      ErrorSnackbar,
      SuccessSnackbar,
      NoteItem,
    },
    mixins: [formHelperMixin],
    props: {
      testator: {
        required: true,
        type: Object,
      },
    },
    data() {
      return {
        comment: null,
        showSuccess: false,
        successMessage: null,
        notes: [],
      };
    },
    methods: {
      createNote() {
        const testatorId = this.testator.id;
        const comment = this.comment;

        this.$apollo
          .mutate({
            mutation: CREATE_NOTE_MUTATION,
            variables: {
              testatorId,
              comment,
            },
            update: (cache, { data: { createNote } }) => {
              this.updateCacheAfterCreateNote(cache, createNote);
            },
          })
          .then(data => {
            this.buttonLoading = false;
            this.showSuccessMessage();
            this.comment = null;
          })
          .catch(error => {
            this.displayError();
            throw error;
          });
      },
      updateCacheAfterCreateNote(cache, createNote) {
        const query = {
          query: TESTATOR_NOTES_QUERY,
          variables: { id: this.testator.id },
        };
        const data = cache.readQuery(query);

        data.testator.notes.push(createNote);

        cache.writeQuery({ ...query, data });
      },
      showSuccessMessage() {
        this.successMessage = 'Note successfully created';
        this.showSuccess = true;
      },
    },
    apollo: {
      notes: {
        query: TESTATOR_NOTES_QUERY,
        variables() {
          return {
            id: this.testator.id,
          };
        },
        update: data => data.testator.notes,
      },
    },
  };
</script>
